import React, { useState, useEffect } from 'react';
import './SpanishLinksTable.css';
import axios from 'axios';

function SpanishLinksTable() {
    const [links, setLinks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await axios.get('/spanish-links-table.json');
                setLinks(response.data);
            } catch (err) {
                console.error("Error fetching links:", err);
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="spanish-links-container">
            <table className="spanish-links-table">
                <thead>
                    <tr>
                        <th className="category-header">News</th>
                        <th className="category-header">Sports</th>
                        <th className="category-header">TV</th>
                        <th className="category-header">Real Estate</th>
                        <th className="category-header">Jobs</th>
                        <th className="category-header">Finance</th>
                        <th className="category-header">Shopping</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {links.filter(link => link.category === "News").map((link, index) => (
                                <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "Sports").map((link, index) => (
                                 <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "TV").map((link, index) => (
                                 <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "Real Estate").map((link, index) => (
                                <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "Jobs").map((link, index) => (
                                 <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "Finance").map((link, index) => (
                                <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                        <td>
                            {links.filter(link => link.category === "Shopping").map((link, index) => (
                                <a key={index} href={link.url}>{link.name}</a>
                            ))}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default SpanishLinksTable;